import { render, staticRenderFns } from "./PopoverAvoirFacture.vue?vue&type=template&id=5565fbd9&"
import script from "./PopoverAvoirFacture.vue?vue&type=script&lang=js&"
export * from "./PopoverAvoirFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports